import { render, staticRenderFns } from "./NewEditor.vue?vue&type=template&id=b1147bd0&scoped=true&"
import script from "./NewEditor.vue?vue&type=script&lang=js&"
export * from "./NewEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewEditor.vue?vue&type=style&index=0&id=b1147bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1147bd0",
  null
  
)

export default component.exports